export default () => ({
  list: [],
  employeeList: [],
  listInMonth: [],
  status: {
    1: '未実行',
    2: '進行中',
    3: '完了',
    4: '削除'
  },
  proposal: [],
  comments: [],
  proposalId: null,
  proposalFrom: 1,
  currentStatus: 0,
  currentPriority: 0,
  currentTags: [],
  thisMonthProposalTotal: 0,
  proposalsDeadlineInMonth: [],
  todoDashboard: [],
  todoChartDashboard: [],
  initTodoDashboard: true,
  isMyTodo: false,
})
